import { render, staticRenderFns } from "./DownLoadFile.vue?vue&type=template&id=6f149662&"
import script from "./DownLoadFile.vue?vue&type=script&lang=js&"
export * from "./DownLoadFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports